import { RootState } from '@/App/store';

export const selectLogin = (state: RootState) => state.login;
